import { call, put } from 'redux-saga/effects'
import ListUserActions from '../Redux/ListUserRedux'
import LoginActions from '../Redux/LoginRedux'
export function* listUser(api, { params }) {
  try {
    const res = yield call(api, params)
    if (res === 'Unauthorized') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.data) {
      yield put(ListUserActions.listUserSuccess(res.data))
    } else {
      yield put(ListUserActions.listUserFailure(res))
    }
  } catch (error) {
    yield put(ListUserActions.listUserFailure(error.message))
  }
}
